import React from 'react'
import { Trans } from 'react-i18next'

/** Dashboard filters step component */
export const DashboardTableFiltersStep: React.FC = () => {
  return <Trans i18nKey="emobility.tour.dashboard-filters" components={{ strong: <strong /> }} />
}
